import { useState } from "react";
import OwnerAccessModal from "./OwnerAccessModal";
import { HOME } from "@/constants/testIds";

export default function Footer({ config }) {
  const [open, setOpen] = useState(false);
  const businessName = config?.business_name || "Cakesbyky";

  return (
    <footer className="bg-white border-t border-slate-100 mt-24">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src="/cakesbyky-logo.png?v=2" alt={businessName} className="h-14 w-auto object-contain mb-3 -ml-2" />
            <p className="text-sm text-slate-500 max-w-xs">
              {config?.tagline || "Treats for every occasion!"}
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-slate-400 mb-3">Contact</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              {config?.email && <li>{config.email}</li>}
              {config?.phone && <li>{config.phone}</li>}
              {config?.instagram && <li>@{config.instagram.replace("@", "")}</li>}
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-slate-400 mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><a href="#menu" className="hover:text-[color:var(--brand-navy)] transition-colors">Menu</a></li>
              <li><a href="#book" className="hover:text-[color:var(--brand-navy)] transition-colors">Book an Order</a></li>
              <li><a href="#about" className="hover:text-[color:var(--brand-navy)] transition-colors">About</a></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center mt-12 pt-6 border-t border-slate-100 gap-3">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} {businessName}. Handmade with love.</p>
          <button
            data-testid={HOME.ownerAccessLink}
            onClick={() => setOpen(true)}
            className="subtle-link"
          >
            Owner Access
          </button>
        </div>
      </div>
      <OwnerAccessModal open={open} onOpenChange={setOpen} />
    </footer>
  );
}
